import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import useOutsideDetector from "../utils/useOutsideDetector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import usePrevious from "../utils/usePrevious";
import getScrollbarWidth from "../utils/getScrollbarWidth";

const Modal = ({
    isWithCloseButton,
    closeOnOutsideClick,
    isOpen,
    onClose,
    children,
    className,
    id,
}) => {
    const ModalBoxRef = useRef();
    const ModalBoxWrapperRef = useRef();
    const classOpen = isOpen ? "is-open" : "";
    const prevIsOpen = usePrevious(isOpen);

    useOutsideDetector(
        ModalBoxRef,
        () => {
            if (isOpen && closeOnOutsideClick) {
                onClose();
            }
        },
        [isOpen, closeOnOutsideClick],
    );

    /**
     * Scrollbar toggler, prevent double scroll in the browser
     * @link https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
     */
    useEffect(() => {
        // If parent location is different => this site is inside an iframe
        const IS_INSIDE_IFRAME = window.location !== window.parent.location;

        if (!prevIsOpen && isOpen) {
            // Opening Modal, make body overflow hidden, to prevent double scrollbar
            const body = document.getElementsByTagName("body")[0];
            const padRight = getScrollbarWidth();

            // body.style.paddingRight = IS_INSIDE_IFRAME ? "0px" : padRight + "px";
            body.style.overflowY = "hidden";
            ModalBoxWrapperRef.current.scrollTop = 0;
            ModalBoxWrapperRef.current.style.overflowY = "auto";
        } else if (prevIsOpen && !isOpen) {
            // Closing Modal, change body overflow to normal
            const body = document.getElementsByTagName("body")[0];

            ModalBoxWrapperRef.current.style.overflowY = "hidden";
            body.style.paddingRight = 0;
            // body.style.overflowY = IS_INSIDE_IFRAME ? "auto" : "scroll";
        }

        return () => null;
    }, [isOpen]);

    return (
        <div className={`modal ${classOpen} ${className}`} id={id}>
            <div className="modal-wrapper" id="modal-wrapper">
                <div
                    className="modal-box-wrapper"
                    id="modal-box-wrapper"
                    ref={ModalBoxWrapperRef}
                >
                    <div className="modal-box" id="modal-box" ref={ModalBoxRef}>
                        {isWithCloseButton && (
                            <button className="modal-close" onClick={onClose}>
                                <FontAwesomeIcon
                                    icon={["far", "times"]}
                                    className="btn-icon"
                                />
                            </button>
                        )}

                        <div className="modal-inner" id="modal-inner">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Modal.propTypes = {
    isWithCloseButton: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    className: PropTypes.string,
    id: PropTypes.string,
};

Modal.defaultProps = {
    isWithCloseButton: true,
    closeOnOutsideClick: true,
    onClose: () => {},
    className: "",
};

export default Modal;
